import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const listIdentityProvidersTE = <E = CF.API.ApiError>(
  { orgId, params = '' }: { orgId: string; params?: string },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Organizations.ListIdentityProvidersResponse> =>
  fetchTE<CF.API.Organizations.ListIdentityProvidersResponse, E>(
    {
      path: `/api/_api/v2/organizations/${orgId}/identity_providers${params ? `?${params}` : ''}`,
      method: 'GET',
    },
    onRejected,
  );
